import React, { useState, useEffect, Fragment } from "react";

const EditItem = ({ type, onSave, isDark, isDisableSave }) => {
  const [isEditing, setEditing] = useState(false);
  const [value, setValue] = useState("");
  useEffect(() => {
    setValue(type.default_value);
  }, [type]);
  const onChangeValue = ({ target }) => {
    setValue(target.value);
  };
  return (
    <Fragment>
      <h4 className="section-title" style={{ marginTop: 30 }}>
        {type.title}
      </h4>
      <div>
        <input
          type="text"
          name="value"
          onChange={onChangeValue}
          style={{
            width: 180,
            height: 38,
            fontFamily: "monospace",
          }}
          value={value}
          disabled={isEditing ? "" : "disabled"}
        />
        {!isDisableSave && (
          <button
            className="btn"
            style={{
              backgroundColor: "darkgray",
              color: "white",
              marginLeft: 5,
            }}
            onClick={() => {
              if (isEditing) onSave(value);
              setEditing(!isEditing);
            }}
          >
            {isEditing ? "Save" : "Edit"}
          </button>
        )}
      </div>
    </Fragment>
  );
};

export default EditItem;



// WEBPACK FOOTER //
// ./src/screens/super_retailer/components/EditItem.js